import { Directive } from '@angular/core';
import { AbstractControl, AsyncValidator, NG_ASYNC_VALIDATORS, ValidationErrors } from '@angular/forms';
import { Observable, timer } from 'rxjs';
import { distinctUntilChanged, map, switchMap } from 'rxjs/operators';
import { UserService } from '../services/user.service';

const debounce = 250;

@Directive({
  selector: '[thUniqueUsernameValidator]',
  providers: [
    {
      provide: NG_ASYNC_VALIDATORS,
      useExisting: UniqueUsernameValidatorDirective,
      multi: true
    }
  ]
})
export class UniqueUsernameValidatorDirective implements AsyncValidator {
  constructor(private userService: UserService) {}

  validate(control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {
    // Timer used for debouncing so the request doesn't get executed for every keystroke.
    // Adapted from: https://stackoverflow.com/a/45007974
    return timer(debounce).pipe(
      distinctUntilChanged(),
      switchMap(() => {
        return this.userService.usernameExists(control.value).pipe(
          map((usernameExists) => {
            return usernameExists ? { entityExists: true } : null;
          })
        );
      })
    );
  }
}
